import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const TrackedMeetings = withSafeSuspense(
  lazy(async () => ({
    default: (await import('./tracked_meetings')).TrackedMeetings,
  }))
)

export const ExternalTrackedMeetings = withSafeSuspense(
  lazy(async () => ({
    default: (await import('./external_page')).ExternalPage
  }))
)

export const LiteRecapView = withSafeSuspense(
  lazy(async () => ({
    default: (await import('./lite/lite_recap_view')).LiteRecapView
  }))
)
